<template>
  <div class="modal fade" 
    role="dialog" 
    style="display:block;" 
    tabindex="-1"
    :class="{ 'in': isOpen }" 
    v-show="isOpen">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <i class="fa fa-bell"></i>
          &nbsp;&nbsp;
          <strong>{{ data.title }}</strong> - <em class="small">{{ time }}</em>
        </div>
        <div class="modal-body">
          <div v-html="data.html"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default"
            @click="dismissAlert()">
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DISMISS_NOTIFICATION } from '@/vuex/types'
  import Util from '@server/util'
  export default {
    name: 'ModalAlert',
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object
      },
      alertUuid: {
        type: String
      }
    },
    computed: {
      time () {
        let min = moment().diff(moment(this.data.createdAt), 'minutes')
        if (min < 5) {
          return 'now'
        } else if (min < 60 && min >= 5) {
          return min + ' min ago'
        } else if (min >= 60 && min < 1440) {
          return Util.round(min / 60).toFixed() + ' hours ago'
        } else {
          return Util.round(min / 60 / 24).toFixed() + ' days ago'
        }
      }
    },
    methods: {
      dismissAlert () {
        this.$store.dispatch(DISMISS_NOTIFICATION, this.alertUuid)
        this.$emit('dismiss')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ModalAlert.vue